import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../constants/routes';
import { useRailsContext } from '../contexts/RailsContext';

export const PublicOnlyRoute = ({ children }) => {
  const { currentUser } = useRailsContext();
  const location = useLocation();
  const isEditMode = location.state?.editMode;
  const previousData = location.state?.registrationData;
    
  if (currentUser && isEditMode && previousData?.status === 'rejected') {
    return children;
  }
  
  if (currentUser) {
    return <Navigate to={APP_ROUTES.ROOT} replace />;
  }
  
  return children;
};

export const PrivateRoute = ({ children }) => {
  const { currentUser } = useRailsContext();

  if (!currentUser) {
    window.location.href = APP_ROUTES.AUTH_SIGN_IN;
    return null;
  }

  const hasPendingApproval = currentUser.roles?.includes('pending_approval');

  if (hasPendingApproval) {
    return children;
  }

  return <Navigate to={APP_ROUTES.ROOT} replace />;
};

export const PendingReviewRoute = ({ children, registrationData }) => {
  const { currentUser } = useRailsContext();

  if (!currentUser) {
    return <Navigate to={APP_ROUTES.ROOT} replace />;
  }
  
  if (!registrationData?.status || registrationData.status !== 'rejected') {
    return <Navigate to={APP_ROUTES.ROOT} replace />;
  }
  
  return children;
}; 